import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -10, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export async function shareContent({ title, text, url }) {
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return "shared";
    } catch (e) {
      if (e.name === "AbortError") return "cancelled";
    }
  }
  try {
    await navigator.clipboard.writeText(`${text} ${url}`);
    return "copied";
  } catch {
    window.open(url, "_blank", "noopener");
    return "opened";
  }
}

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/07098315-3e28-4b2f-a72c-8720861376a1/images/49bbc5a28593695877b619c9bbe77013b5151aed6ab150b35e78fdd64377357c.jpeg",
  fountain: "https://static.prod-images.emergentagent.com/jobs/07098315-3e28-4b2f-a72c-8720861376a1/images/818a08cf52265a13935c10621a4eb3efdae870ea5a189e31fbe91dba57dcaf90.jpeg",
  dove: "https://static.prod-images.emergentagent.com/jobs/07098315-3e28-4b2f-a72c-8720861376a1/images/e8a6e56b04cf1d086da0f53f3fda42dc3f408143abe32210251244f60ca0ce6d.jpeg",
  water: "https://static.prod-images.emergentagent.com/jobs/07098315-3e28-4b2f-a72c-8720861376a1/images/13cd197ff8efab9d70359202c5cf8c65db8e7d14a2b36729e7771f17f7e1b09b.jpeg",
};

// Streaming chat: POST and read SSE, calling onDelta for each token.
export async function streamChat(ministerId, sessionId, message, onDelta, onDone, onError) {
  try {
    const resp = await fetch(`${API}/chat/${ministerId}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id: sessionId, message }),
    });
    if (!resp.ok || !resp.body) throw new Error("stream failed");
    const reader = resp.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split("\n\n");
      buffer = parts.pop();
      for (const part of parts) {
        const line = part.trim();
        if (!line.startsWith("data:")) continue;
        const payload = JSON.parse(line.slice(5).trim());
        if (payload.delta) onDelta(payload.delta);
        if (payload.error) onError && onError(payload.error);
        if (payload.done) { onDone && onDone(); return; }
      }
    }
    onDone && onDone();
  } catch (e) {
    onError && onError("Connection interrupted. Please try again.");
  }
}
